(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nandz-card-info"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nzAddInit) return;
    window.__nzAddInit = true;

    function root() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    }

    function toast(text, isError) {
      var t = document.createElement('div');
      t.className = 'nz-toast' + (isError ? ' is-err' : '');
      t.setAttribute('role', 'status');
      var span = document.createElement('span');
      span.textContent = text;
      t.appendChild(span);
      if (!isError) {
        var a = document.createElement('a');
        a.href = root() + 'cart';
        a.textContent = 'View basket';
        t.appendChild(a);
      }
      document.body.appendChild(t);
      setTimeout(function () { t.classList.add('is-in'); }, 10);
      setTimeout(function () {
        t.classList.remove('is-in');
        setTimeout(function () { t.remove(); }, 300);
      }, 3500);
    }

    function setCount(n) {
      document.querySelectorAll('.nz-cartn').forEach(function (el) { el.textContent = n; });
      document.dispatchEvent(new CustomEvent('nz:cart-updated', { detail: { count: n } }));
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.classList || !e.target.classList.contains('nz-cardbuy__qty')) return;
      e.preventDefault();
      var b = e.target.closest('[data-nz-add]').querySelector('[data-nz-btn]');
      if (b) b.click();
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nz-btn]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var row = btn.closest('[data-nz-add]');
      var input = row.querySelector('.nz-cardbuy__qty');
      var qty = parseInt(input.value, 10);
      if (!qty || qty < 1) qty = 1;
      input.value = qty;
      var label = btn.querySelector('[data-nz-label]');
      var original = label.textContent;
      btn.disabled = true;
      label.textContent = 'Adding...';

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(row.getAttribute('data-id'), 10), quantity: qty }] })
      })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, data: d }; });
        })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add this product.');
          return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCount(cart.item_count);
          label.textContent = 'Added';
          btn.classList.add('is-done');
          toast(qty + ' x ' + row.getAttribute('data-title') + ' added to your basket');
          setTimeout(function () {
            label.textContent = original;
            btn.classList.remove('is-done');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function (err) {
          label.textContent = original;
          btn.disabled = false;
          toast(err.message || 'Something went wrong. Please try again.', true);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
